






import { Vue, Component } from 'vue-property-decorator'

@Component({ name: 'settings-section' })
export default class SettingsSection extends Vue {}
